import React from 'react';
import SmartMeterList from './SmartMeterList';

const ConsumptionList = () => {
  return <SmartMeterList />;
};

export default ConsumptionList;
